import { render, staticRenderFns } from "./206.vue?vue&type=template&id=475f8d70&scoped=true&"
var script = {}
import style0 from "./206.vue?vue&type=style&index=0&id=475f8d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475f8d70",
  null
  
)

export default component.exports